import { Link } from 'react-router-dom';
import type { News } from '@/types';
import { formatDate, newsPath } from '@/lib/catalog';

interface NewsRowProps {
  item: News;
  showSummary?: boolean;
}

export default function NewsRow({ item, showSummary = false }: NewsRowProps) {
  return (
    <Link
      to={newsPath(item)}
      className="group flex items-start gap-3 border-b border-background-200 py-3.5 last:border-b-0"
    >
      <span className="mt-1.5 flex h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500" />
      <div className="min-w-0 flex-1">
        <h3 className="line-clamp-2 text-sm font-medium text-foreground-900 transition group-hover:text-primary-600 md:text-[15px]">
          {item.title}
        </h3>
        {showSummary && <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">{item.summary}</p>}
        <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-price-tag-3-line" />
            {item.category}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {formatDate(item.date)}
          </span>
        </div>
      </div>
    </Link>
  );
}